export const isCollapsibleMenu = (menu: SideMenu): menu is CollapsibleMenu =>
  typeof menu === 'object' && (menu as CollapsibleMenu).collapse

export const isLeafMenu = (menu: SideMenu): menu is LeafMenu =>
  typeof menu === 'object' && (menu as LeafMenu).path !== undefined
